(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name trek.controller:SearchCtrl
   *
   * @description
   *
   */
  angular
    .module('trek')
    .controller('SearchCtrl', SearchCtrl);

  function SearchCtrl() {
    var vm = this;
    vm.ctrlName = 'SearchCtrl';
  }
}());
